import PaymentManager_v2 from './PaymentManager_v2';

export default PaymentManager_v2;
